"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataAccessError = void 0;
const is_error_1 = require("./is-error");
const error_codes_1 = require("../lib/error-codes");
const args_1 = require("../lib/args");
/**
 * A generic error for when a data store fails to retrieve or update. This error will surface to the user
 * as a unknown error as there is nothing the user can do at this point to fix the request.
 */
class DataAccessError extends is_error_1.IsError {
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.DATA_ACCESS, DataAccessError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.SERVER_ERROR, errorArgs?.userMessage || error_codes_1.ErrorMessage.SOMETHING_WENT_WRONG, originalError, errorArgs);
    }
}
exports.DataAccessError = DataAccessError;
